import { createI18n } from 'vue-i18n';
import ru from '@/locales/ru.json';
//import axios from 'axios';

import AuthModel from '@/models/AuthModel.js';

export default class AppModel
{
	/**
	 * Конструктор
	 */
	constructor()
	{
		this.hcaptcha_sitekey = 'e9c8a7dc-f9ca-437d-bbc5-ba9fa661b8a6';
		
		this.langs = ['ru'];
		this.langsName = {
			ru: 'Русский',
		};
		this.title = '';
		this.i18n = createI18n({
			legacy: false,
			locale: 'ru',
			messages: { ru },
		});
		
		this.auth = new AuthModel();
		
		this.booster_health_count = 2;	// количество генерируемых бонусов увеличения здоровья персонажа на карте
		this.booster_damage_count = 2;	// количество генерируемых бонусов увеличения атаки персонажа на карте
		this.bandits_count = 6;			// количество генерируемых бандитов на карте
		
		this.booster_health_plus = 80;			// на сколько единиц увеличивается здоровье при получении бонуса
		this.booster_damage_plus = 4;			// на сколько единиц увеличивается атака при получении бонуса
		this.booster_evasion_plus = 2;			// на сколько процентов увеличивается шанс уклонения от атаки при получении бонуса
		this.booster_exp_nextlevel_plus = 20;	// на сколько единиц увеличивается опыт при переходе на новый уровень
		this.booster_exp_open_plus = 5;			// на сколько единиц увеличивается опыт при открытии ячейки
		this.booster_exp_health_plus = 5;		// на сколько единиц увеличивается опыт при получении бонуса к здоровью в ячейке
		this.booster_exp_damage_plus = 5;		// на сколько единиц увеличивается опыт при получении бонуса к силе атаки в ячейке
		this.booster_exp_evasion_plus = 5;		// на сколько единиц увеличивается опыт при получении бонуса к шансу уклонения от атаки
		
		this.character_hp_def = 200;			// единицы жизни персонажа по умолчанию
		this.character_damage_min_def = 20;		// минимальный урон персонажа по умолчанию
		this.character_damage_max_def = 30;		// максимальный урон персонажа по умолчанию
		this.character_evasion_def = 5;			// процент вероятности уклонения от удара по умолчанию
		this.character_level_def = 1;			// количество прошедших уровней по умолчанию
		this.character_exp_def = 0;				// общий полученный опыт по умолчанию
		
		this.bandits_hp_def = 60;				// единицы жизни бандитов по умолчанию
		this.bandits_damage_min_def = 15;		// минимальный урон бандитов по умолчанию
		this.bandits_damage_max_def = 20;		// максимальный урон бандитов по умолчанию
		this.bandits_evasion_def = 1;			// процент вероятности уклонения от удара по умолчанию
		
		this.bandits_health_nextlevel_plus = 10;	// на сколько единиц увеличивается здоровье бандитов при переходе на новый уровень
		this.bandits_damage_nextlevel_plus = 3;		// на сколько единиц увеличивается атака бандитов при переходе на новый уровень
		this.bandits_evasion_nextlevel_plus = 1;	// на сколько единиц увеличивается шанс уклонения от атаки бандитов при переходе на новый уровень
		this.bandits_health_nextlevel_plus2 = 10;	// на сколько единиц дополнительно увеличивается здоровье бандитов при переходе на новый уровень, если на текущем уровне не все бандиты зачищены
		this.bandits_damage_nextlevel_plus2 = 1;	// на сколько единиц дополнительно увеличивается атака бандитов при переходе на новый уровень, если на текущем уровне не все бандиты зачищены
		this.bandits_evasion_nextlevel_plus2 = 2;	// на сколько единиц дополнительно увеличивается шанс уклонения от атаки бандитов при переходе на новый уровень, если на текущем уровне не все бандиты зачищены
		this.bandits_health_nextlevel_plus3 = 10;	// на сколько единиц дополнительно увеличивается здоровье бандитов при переходе на новый уровень, если на текущем уровне бандиты вообще не зачищены
		this.bandits_damage_nextlevel_plus3 = 3;	// на сколько единиц дополнительно увеличивается атака бандитов при переходе на новый уровень, если на текущем уровне бандиты вообще не зачищены
		this.bandits_evasion_nextlevel_plus3 = 1;	// на сколько единиц дополнительно увеличивается шанс уклонения от атаки бандитов при переходе на новый уровень, если на текущем уровне бандиты вообще не зачищены
		
		this.soundOn = true;		// включить звуки
	}
	
	/**
	 * Set page title
	 */
	setPageTitle(title)
	{
		this.title = title;
		document.title = title;
	}
	
	/**
	 * Set app lang
	 */
	setLang(lang = 'ru')
	{
		this.i18n.global.locale = lang;
		//axios.defaults.headers.common['Accept-Language'] = lang;
		document.querySelector('html').setAttribute('lang', lang);
		return lang;
	}
	
	/**
	 * Returns lang
	 */
	getLang()
	{
		//return this.i18n.locale;
		return this.i18n.global.locale;
	}
	
	pageReload()
	{
		document.location.reload();
	}
	
	/**
	 * Получение таблицы результатов
	 */
	async doGetResults(params = {})
	{
		try {
			const response = await axios.get('/api/results', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Отправка результата
	 */
	async doSetResult(params = {})
	{
		try {
			const response = await axios.post('/api/results', params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
}
